import React from 'react';
import { Link } from 'react-router-dom';
import { FaUserMd, FaHospital, FaCalendarCheck, FaHeartbeat } from 'react-icons/fa';
import './Home.css';

const Home = () => {
  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="container">
          <div className="hero-content">
            <h1>Welcome to New Jeevan Deep</h1>
            <h2>Medical & Health Care Center</h2>
            <p>Providing Quality Healthcare Services with Compassion and Excellence</p>
            <div className="hero-buttons">
              <Link to="/book-appointment" className="btn btn-primary btn-lg">
                Book Appointment
              </Link>
              <Link to="/doctors" className="btn btn-outline-light btn-lg">
                Find a Doctor
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section section">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6">
              <div className="feature-card">
                <div className="feature-icon">
                  <FaUserMd />
                </div>
                <h3>Expert Doctors</h3>
                <p>Experienced medical professionals dedicated to your health</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="feature-card">
                <div className="feature-icon">
                  <FaHospital />
                </div>
                <h3>Modern Facilities</h3>
                <p>State-of-the-art medical equipment and infrastructure</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="feature-card">
                <div className="feature-icon">
                  <FaCalendarCheck />
                </div>
                <h3>Easy Appointments</h3>
                <p>Book appointments online quickly and conveniently</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="feature-card">
                <div className="feature-icon">
                  <FaHeartbeat />
                </div>
                <h3>24/7 Emergency</h3>
                <p>Round-the-clock emergency medical services</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-section section bg-light">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="section-title text-left">
                <h2>About New Jeevan Deep</h2>
                <p>
                  New Jeevan Deep Medical Center has been serving the community for years,
                  providing comprehensive healthcare services with a patient-first approach.
                  Our team of experienced doctors and medical staff are committed to
                  delivering the highest quality care.
                </p>
                <p>
                  We offer a wide range of medical services including emergency care,
                  specialized treatments, diagnostic services, and preventive healthcare.
                </p>
              </div>
              <Link to="/about" className="btn btn-primary">Learn More</Link>
            </div>
            <div className="col-lg-6">
              <div className="about-image">
                <img src="/images/about-hospital.jpg" alt="Hospital" className="img-fluid" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Departments Section */}
      <section className="departments-section section">
        <div className="container">
          <div className="section-title">
            <h2>Our Departments</h2>
            <p>Comprehensive medical services across various specializations</p>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <div className="department-card">
                <h4>Cardiology</h4>
                <p>Expert heart care and cardiovascular treatment</p>
                <Link to="/departments/cardiology">Learn More →</Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="department-card">
                <h4>Orthopedics</h4>
                <p>Bone and joint care with advanced treatment options</p>
                <Link to="/departments/orthopedics">Learn More →</Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="department-card">
                <h4>Pediatrics</h4>
                <p>Comprehensive child healthcare services</p>
                <Link to="/departments/pediatrics">Learn More →</Link>
              </div>
            </div>
          </div>
          <div className="text-center mt-4">
            <Link to="/departments" className="btn btn-outline-primary">
              View All Departments
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Need Medical Assistance?</h2>
            <p>Book an appointment with our expert doctors today</p>
            <Link to="/book-appointment" className="btn btn-light btn-lg">
              Book Appointment Now
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
